import ButtonSubscribe from '@javascripts/components/button_subscribe';
import TopicAdapter from '@javascripts/adapters/topic_adapter';
import { PlayerEnvironment } from './player_environment';

export default class PlayerContentPreview {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
    this._buttonSubscribe = new ButtonSubscribe({ tech, data });
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  previewDuration(){
    if(this.data()){
      return this.data().previewDuration();
    }

    return undefined;
  }

  buttonSubscribe() {
    return this._buttonSubscribe;
  }

  init() {
    this.buttonSubscribe().init();
    if(this.hasPreviewDuration()){
      this.onPlayingPreviewDurationHandler();
    } else{
      this.videoEndedHandler();
    }
  }

  onPlayingPreviewDurationHandler() {
    this.tech().one('playing', this.previewDurationEndedHandler.bind(this));
  }

  videoEndedHandler() {
    this.tech().on('ended', this.onPreviewEnded.bind(this));
  }

  previewDurationEndedHandler(){
    setTimeout(this.onPreviewEnded.bind(this), (this.previewDuration() + 1) * 1000);
  }

  onPreviewEnded() {
    if (PlayerEnvironment.isOSiOS() && (this.tech().isInAdMode() || this.tech().duration() <= 0)) return;
    TopicAdapter.publish('player/paymentblocker/show', { "source": "preview end" });
    this.tech().dispose();
  }

  hasPreviewDuration(){
    return this.previewDuration() != undefined && this.previewDuration() !== -1;
  }
}
